var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg078Power(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3V12C13 12.5523 12.5523 13 12 13C11.4478 13 11 12.5523 11 12V3C11 2.44772 11.4478 2 12 2C12.5523 2 13 2.44772 13 3ZM5.25004 6.09C5.6148 5.6763 6.24565 5.63603 6.66004 6C7.07375 6.36476 7.11402 6.9956 6.75004 7.41C4.26814 10.2242 4.44666 14.4948 7.15476 17.0921C9.86286 19.6894 14.1372 19.6894 16.8453 17.0921C19.5534 14.4948 19.7319 10.2242 17.25 7.41C16.8861 6.9956 16.9263 6.36476 17.34 6C17.7544 5.63603 18.3853 5.6763 18.75 6.09C21.9411 9.70827 21.7115 15.1991 18.2297 18.5384C14.7479 21.8778 9.25224 21.8778 5.77039 18.5384C2.28855 15.1991 2.05903 9.70827 5.25004 6.09Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg078Power);
export default __webpack_public_path__ + "static/media/078-power.0a286140a784ced44bbcee1af95308f7.svg";
export { ForwardRef as ReactComponent };